import { Controller } from "@hotwired/stimulus"

// UI-08: add, remove and reorder slide fieldsets; positions renumbered 1..n.
export default class extends Controller {
  static targets = ["template", "list", "item", "position", "number", "destroy"]

  connect() {
    this.renumber()
  }

  add() {
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}`)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.renumber()
  }

  remove(event) {
    const item = event.target.closest('[data-nested-slides-target="item"]')
    if (item.dataset.newRecord === "true") {
      item.remove()
    } else {
      item.querySelector('[data-nested-slides-target="destroy"]').value = "1"
      item.hidden = true
    }
    this.renumber()
  }

  up(event) {
    const item = event.target.closest('[data-nested-slides-target="item"]')
    const previous = this.visibleItems[this.visibleItems.indexOf(item) - 1]
    if (previous) previous.before(item)
    this.renumber()
  }

  down(event) {
    const item = event.target.closest('[data-nested-slides-target="item"]')
    const next = this.visibleItems[this.visibleItems.indexOf(item) + 1]
    if (next) next.after(item)
    this.renumber()
  }

  // private

  get visibleItems() {
    return this.itemTargets.filter((item) => !item.hidden && this.listTarget.contains(item))
  }

  renumber() {
    this.visibleItems.forEach((item, index) => {
      item.querySelector('[data-nested-slides-target="position"]').value = index + 1
      item.querySelector('[data-nested-slides-target="number"]').textContent = index + 1
    })
  }
}
